<template>
  <tr v-if="requirement.editing" class="requirement row age editing" key="editing">
    <can I="edit" a="Opportunity">
      <th v-if="first" class="has-text-right">Candidate</th>
      <td v-else class="has-text-right">
        {{ requirement.mandatory ? 'and' : 'or'}}
      </td>
      <td colspan="2">
        <v-toolbar flat class="transparent">
          <v-select v-model="requirement.mandatory" :items="[{ text: 'must', value: true }, { text: 'could', value: false }]" />
          <span class="body px-2">be</span>
          <v-select v-model="requirement.negative" :items="[{ text: 'less than', value: true }, { text: 'at least', value: false }]" />
          <label class="body px-2"></label>
          <v-text-field v-model="requirement.value" type="number"></v-text-field>
          <label class="body px-2">years old</label>

          <v-spacer />

          <!-- Cancel Button -->
          <v-tooltip left color="grey darken-3">
            <v-btn small flat fab
              key="cancel"
              @click="cancel"
              slot="activator"
              color="grey"
            >
             <v-icon>mdi-cancel</v-icon>
            </v-btn>
            <span>Cancel</span>
          </v-tooltip>
          <!-- Delete Button -->
          <v-tooltip left v-if="requirement.id" color="grey darken-3">
            <v-btn small flat error fab
              key="delete"
              @click="destroy"
              slot="activator"
              color="error"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
          <!-- Submit Button -->
          <v-tooltip left color="grey darken-3">
            <v-btn small fab
              slot="activator"
              @click="submit"
              key="save"
              color="primary"
            >
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
            <span v-if="requirement.id">Update</span>
            <span v-else>Create</span>
          </v-tooltip>
        </v-toolbar>
      </td>
    </can>
  </tr>
  <tr v-else class="requirement row age viewing" key="viewing">
    <th v-if="first" class="text-xs-right">Candidate</th>
    <td v-else class="text-xs-right">
      {{ requirement.mandatory ? 'and' : 'or' }}
    </td>
    <td>
      {{ requirement.mandatory ? 'must' : 'could' }}
      be
      {{ requirement.negative ? 'less than' : 'at least' }}
      <em>{{ requirement.value }}</em>
      years old
    </td>
    <can I="edit" a="Opportunity">
      <td class="text-xs-right">
        <v-btn small flat @click.prevent="edit" color="primary">Edit</v-btn>
      </td>
    </can>
  </tr>
</template>

<script>
  // Vue Component
  export default {
    props: {
      requirement: { type: Object, required: true },
      first:       { type: Boolean }
    },
    computed: {
      creating() { return this.requirement.id == null }
    },
    methods: {
      edit() { this.requirement.editing = true },

      cancel() {
        this.$store.dispatch('opportunities/fetch', this.$route.params.id)
        this.requirement.editing = false
      },

      destroy() {
        if (this.requirement.id) {
          this.$store.dispatch('requirements/destroy', this.requirement)
        } else {
          this.$store.dispatch('opportunities/fetch', this.$route.params.id)
        }
      },
      submit() {
        if (this.requirement.id) {
          this.$store.dispatch('requirements/update', this.requirement).then(
            (feedback) => {
              if (feedback) {
                this.$store.commit('snackbar', { text: 'There was a problem updating the requirement', type: 'error' })
                this.requirement = feedback
              } else {
                this.$store.commit('snackbar', { text: 'Requirement was updated successfully', type: 'success' })
              }
            }
          )
        } else {
          this.$store.dispatch('requirements/create', this.requirement).then(
            (feedback) => {
              if (feedback) {
                this.$store.commit('snackbar', { text: 'There was a problem creating the requirement', type: 'error' })
                this.requirement = feedback
              } else {
                this.$store.commit('snackbar', { text: 'Requirement was created successfully', type: 'success' })
              }
            }
          )
        }
      }
    }
  }
</script>
